// 同意情報欄
import React, { useState } from 'react';
import Shelf from '../molecules/ShelfInShelf';
import Text from '../molecules/Text';
import { KeyValue } from '../types/KeyValue';
import Heading from '../molecules/Heading';
interface Props {
  agreement_info: KeyValue[];
  heading_disabled?: boolean;
}

const AgreementInfo: React.FC<Props> = ({ agreement_info, heading_disabled }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      {!heading_disabled && <Heading label="同意・署名" size="m" />}
      <Shelf
        handleClick={() => {
          setOpen(prev => !prev);
        }}
        is_open={open}
        id="agreement-info"
        label="連帯債務者等の同意・不同意"
      >
        {agreement_info.map((agreement, index) => {
          return (
            <Text
              key={index}
              id={`agreement-info-${index}`}
              disabled={false}
              label={agreement.key}
              handleChange={() => {}}
              value={agreement.value}
              placeholder={''}
              looks_inactive={true}
            />
          );
        })}
      </Shelf>
    </>
  );
};

export default AgreementInfo;
